import React, { createContext, useEffect, useReducer } from 'react'
import newsReducer from './newsReducer'
import { firestore } from '../../services/firebase'
import { SET_NEWS, SET_NEWS_CATEGORIES, SET_MORE_NEWS_AVAILABLE, SET_NEWS_LOADING } from '../types'

import { collection, doc, getDoc, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore'


const NewsContext = createContext()

const NEWS_PAGE_SIZE = 20

const NewsState = ({ children }) => {
  const initialState = {
    news: [],
    newsLoading: false,
    newsLoaded: false,
    newsCategories: [],
    newsCategoriesLoaded: false,
    moreNewsAvailable: false
  }

  const [state, dispatch] = useReducer(newsReducer, initialState)

  useEffect(() => {
    fetchNews()
  }, [])

  const fetchNews = async () => {
    const configsRef = doc(firestore, "configs/items_order")
    const newsCollection = collection(firestore, "news")
    const categoriesCollection = collection(firestore, "news_categories")
    const newsQuery = query(newsCollection, where("published", "==", true), orderBy("date", "desc"), limit(NEWS_PAGE_SIZE))

    const [newsSnapshot, categoriesSnapshot, configsSnapshot] = await Promise.all([getDocs(newsQuery), getDocs(categoriesCollection), getDoc(configsRef)])

    const news = newsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    const categories = categoriesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    const configs = configsSnapshot.data()

    if(configs && configs.news_categories) {
      categories.sort((a, b) => {
        return configs.news_categories.indexOf(a.id) - configs.news_categories.indexOf(b.id)
      })
    }

    dispatch({ type: SET_NEWS, payload: news })
    dispatch({ type: SET_NEWS_CATEGORIES, payload: categories })
    dispatch({ type: SET_MORE_NEWS_AVAILABLE, payload: newsSnapshot.size === NEWS_PAGE_SIZE })
  }

  const fetchMoreNews = async () => {
    if(state.news.length === 0) {
      dispatch({ type: SET_MORE_NEWS_AVAILABLE, payload: false })
      dispatch({ type: SET_NEWS_LOADING, payload: false })
      return
    }

    dispatch({ type: SET_NEWS_LOADING, payload: true })

    // fetch one more than page size to determine if there are more news available

    const lastNewsItem = state.news[state.news.length - 1]
    const newsCollection = collection(firestore, "news")
    const newsQuery = query(newsCollection, where("published", "==", true), orderBy("date", "desc"), startAfter(lastNewsItem.date), limit(NEWS_PAGE_SIZE + 1))

    const newsSnapshot = await getDocs(newsQuery)
    const moreNews = newsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    if(moreNews.length === NEWS_PAGE_SIZE + 1) {
      moreNews.pop()
    }

    dispatch({ type: SET_NEWS, payload: [...state.news, ...moreNews] })
    dispatch({ type: SET_MORE_NEWS_AVAILABLE, payload: newsSnapshot.size === NEWS_PAGE_SIZE + 1 })
  }

  return (
    <NewsContext.Provider value={{
      news: state.news,
      newsLoaded: state.newsLoaded,
      newsCategories: state.newsCategories,
      newsCategoriesLoaded: state.newsCategoriesLoaded,
      moreNewsAvailable: state.moreNewsAvailable,
      fetchMoreNews
    }}>
      {children}
    </NewsContext.Provider>
  )
}

export default NewsState
export { NewsContext }
